import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getEducationPlanOop } from 'services/api';
import type { EducationPlanOopPageParams } from 'services/navigation/types';

export const useEducationPlanOop = () => {
  const { educationPlanId } = useParams<EducationPlanOopPageParams>();
  const [educationPlan, setEducationPlan] = useState<any>(null);

  useEffect(() => {
    if (educationPlanId) {
      getEducationPlanOop(educationPlanId).then((res) => {
        setEducationPlan(res);
      });
    }
  }, [educationPlanId]);

  return {
    state: {
      educationPlan,
    },
  };
};
